import React, {Component} from 'react'; 
import axios from 'axios';
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import withRouter from '../components/withRouter';  
import ExploreContent from '../components/ExploreContent'; 
  
import {api_base_url, base_url} from '../common/Constants';

class Explore extends React.Component{

    constructor(props){
        super(props);

        
        this.state = { 
            loading:1,
            type:[],
            category:[],
            title : ""
        }
    }

     componentDidMount()
    {
        
        var id = this.props.params.id;
        var ids = [];
        var title = "";
        if(id === "about-esta")
        {
            ids = ["who-we-are",'what-we-do',"our-journey","structure","purpose-and-value","ecosystem"];
            title = "About ESTA";
        }
        if(id === "approach")
        {
            ids =  ["how-we-do-it","why-are-we-different","governance","health-and-safety"];
            title = "Approach";
        }
        if(id === "foundation")
        {
            ids = ["natural-heritage", "energy-transition", "hydrogen", "sustainability", "in-country-value"];
            title = "Foundation";
        }

        this.setState({title:title}); 
        this.setState({ids:ids}); 
        this.setState({loading:0});
        
         console.log(id) 
    }
    componentDidUpdate(prevProps)
    {
        if(this.props.params.id !== prevProps.params.id)
        {
                var id = this.props.params.id;
                var ids = [];
                var title = "";
                 if(id === "about-esta")
                {
                    ids = ["who-we-are",'what-we-do',"our-journey","structure","purpose-and-value","ecosystem"];
                    title = "About ESTA";
                }
                if(id === "approach")
                {
                    ids =  ["how-we-do-it","why-are-we-different","governance","health-and-safety"];
                    title = "Approach";
                }
                if(id === "foundation")
                {
                    ids = ["natural-heritage", "energy-transition", "hydrogen", "sustainability", "in-country-value"];
                    title = "Foundation";
                }
                this.setState({title:title}); 
                this.setState({ids:ids}); 
                this.setState({loading:0});
                
        }
    }
   
 
    render()
    {
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
        return (
            <div className="page-wrapper">
                <Header/>  
                <ExploreContent id={this.props.params.id} ids={this.state.ids} title={this.state.title} />  
                <Footer/>
            </div>
       
        )
    }

}
export default withRouter(Explore);